import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('div', {
    staticClass: "booking-status-tabs status-tabs mb-5"
  }, [_c('div', [_vm._v(_vm._s(_vm.t('海运订舱单状态')) + _vm._s(_vm.t('common', '：')))]), _c('a-tabs', {
    attrs: {
      "animated": false,
      "data-permission": "sea_freight_booking_search_status",
      "id": "sea_freight_booking_search_status",
      "size": "small"
    },
    on: {
      "change": _vm.handleTabChange
    },
    model: {
      value: _vm.searchData.order_status,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "order_status", $$v);
      },
      expression: "searchData.order_status"
    }
  }, _vm._l(_vm.statusList, function (item) {
    return _c('a-tab-pane', {
      key: item.value,
      attrs: {
        "tab": item.text + "(" + item.total + ")"
      }
    });
  }), 1)], 1), _c('my-enter-search', {
    staticClass: "mb-10",
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "allow-clear": false
    },
    model: {
      value: _vm.searchData.code_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_type", $$v);
      },
      expression: "searchData.code_type"
    }
  }, [_c('a-select-option', {
    attrs: {
      "data-permission": "sea_freight_booking_search_booking_no",
      "id": "sea_freight_booking_search_booking_no",
      "value": _vm.$enum.seaFreightBooking.CodeType.BOOKING_ORDER_CODE
    }
  }, [_vm._v(_vm._s(_vm.t('海运订舱单号')))]), _c('a-select-option', {
    attrs: {
      "data-permission": "sea_freight_booking_search_container_number",
      "id": "sea_freight_booking_search_container_number",
      "value": _vm.$enum.seaFreightBooking.CodeType.CONTAINER_NUMBER
    }
  }, [_vm._v(_vm._s(_vm.t('海柜号')))]), _c('a-select-option', {
    attrs: {
      "id": "sea_freight_booking_search_reference_number",
      "value": _vm.$enum.seaFreightBooking.CodeType.REFERENCE_NUMBER
    }
  }, [_vm._v(_vm._s(_vm.t('参考编码')))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u53CC\u51FB\u53EF\u6279\u91CF\u67E5\u8BE2"),
      "allowClear": "",
      "maxLength": 100,
      "placeholder": _vm.t('双击可批量查询')
    },
    on: {
      "dblclick": _vm.handleDblClick
    },
    model: {
      value: _vm.searchData.code_value,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "code_value", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "searchData.code_value"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u59CB\u53D1\u6E2F\u53E3"),
      "data-permission": "sea_freight_booking_search_start_port",
      "id": "sea_freight_booking_search_start_port",
      "show-tip": "",
      "placeholder": _vm.t('始发港口'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.start_port,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "start_port", $$v);
      },
      expression: "searchData.start_port"
    }
  }, _vm._l(_vm.startPortList, function (item) {
    return _c('a-select-option', {
      key: item.option_code
    }, [_vm._v(_vm._s(item.option_name))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u76EE\u7684\u6E2F\u53E3"),
      "data-permission": "sea_freight_booking_search_end_port",
      "id": "sea_freight_booking_search_end_port",
      "show-tip": "",
      "placeholder": _vm.t('目的港口'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.end_port,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "end_port", $$v);
      },
      expression: "searchData.end_port"
    }
  }, _vm._l(_vm.endPortList, function (item) {
    return _c('a-select-option', {
      key: item.option_code
    }, [_vm._v(_vm._s(item.option_name))]);
  }), 1), _c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u67DC\u578B"),
      "data-permission": "sea_freight_booking_cabinet_type",
      "id": "sea_freight_booking_cabinet_type",
      "show-tip": "",
      "placeholder": _vm.t('柜型'),
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.cabinet_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "cabinet_type", $$v);
      },
      expression: "searchData.cabinet_type"
    }
  }, _vm._l(_vm.cabinetTypeList, function (item) {
    return _c('a-select-option', {
      key: item.option_code,
      attrs: {
        "value": item.option_code
      }
    }, [_vm._v(_vm._s(item.option_name))]);
  }), 1)], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u521B\u5EFA\u65F6\u95F4"),
      "allow-clear": false,
      "placeholder": _vm.t('创建时间')
    },
    model: {
      value: _vm.searchData.date_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "date_type", $$v);
      },
      expression: "searchData.date_type"
    }
  }, [_c('a-select-option', {
    attrs: {
      "data-permission": "sea_freight_booking_search_created_at",
      "id": "sea_freight_booking_search_created_at",
      "value": _vm.$enum.seaFreightBooking.TimeType.CREATION
    }
  }, [_vm._v(_vm._s(_vm.t('创建时间')))]), _c('a-select-option', {
    attrs: {
      "data-permission": "sea_freight_booking_search_submitted_at",
      "id": "sea_freight_booking_search_submitted_at",
      "value": _vm.$enum.seaFreightBooking.TimeType.SUBMISSION
    }
  }, [_vm._v(_vm._s(_vm.t('提交时间')))])], 1), _c('my-range-picker', {
    attrs: {
      "placeholder": [_vm.t('开始'), _vm.t('结束')],
      "format": "YYYY/MM/DD",
      "limit-range-day": 0
    },
    model: {
      value: _vm.datetimeDefaultValue,
      callback: function ($$v) {
        _vm.datetimeDefaultValue = $$v;
      },
      expression: "datetimeDefaultValue"
    }
  })], 1), _c('span', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "type": "primary",
      "data-sign": "sea_freight_booking_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-sign": "sea_freight_booking_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "ovh mb-15"
  }, [_c('span', {
    staticClass: "fl",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v(_vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', ':')) + " " + _vm._s(_vm.selectedList.length))]), _c('div', {
    staticClass: "ml-20 fl"
  }, [_c('a-dropdown', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'sea_freight_booking_export',
      expression: "'sea_freight_booking_export'"
    }]
  }, [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-permission": "sea_freight_booking_export_all",
      "id": "sea_freight_booking_export_all",
      "data-sign": "sea_freight_booking_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-permission": "sea_freight_booking_export_select",
      "id": "sea_freight_booking_export_select",
      "data-sign": "sea_freight_booking_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": function ($event) {
        return _vm.handleExport(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1), _vm.searchData.order_status === _vm.$enum.seaFreightBooking.seaFreightBookingStatus.DRAFT || _vm.searchData.order_status === _vm.$enum.seaFreightBooking.seaFreightBookingStatus.REJECTED ? _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'sea_freight_booking_discard',
      expression: "'sea_freight_booking_discard'"
    }],
    staticClass: "ml-15",
    attrs: {
      "data-permission": "sea_freight_booking_discard_bulk",
      "id": "sea_freight_booking_discard_bulk",
      "data-sign": "sea_freight_booking_discard_bulk",
      "fbu-analyse-name": $t("\u5E9F\u5F03")
    },
    on: {
      "click": _vm.handleDiscardBulk
    }
  }, [_vm._v(" " + _vm._s(_vm.t('废弃')))]) : _vm._e(), _vm.searchData.order_status === _vm.$enum.seaFreightBooking.seaFreightBookingStatus.DRAFT ? _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'sea_freight_booking_submit',
      expression: "'sea_freight_booking_submit'"
    }],
    staticClass: "ml-15",
    attrs: {
      "data-permission": "sea_freight_booking_submit_bulk",
      "id": "sea_freight_booking_submit_bulk",
      "data-sign": "sea_freight_booking_submit_bulk",
      "fbu-analyse-name": $t("\u63D0\u4EA4")
    },
    on: {
      "click": _vm.handleSubmitBookingBulk
    }
  }, [_vm._v(" " + _vm._s(_vm.t('提交')))]) : _vm._e()], 1), _c('a-button', {
    directives: [{
      name: "permission",
      rawName: "v-permission",
      value: 'sea_freight_booking_add',
      expression: "'sea_freight_booking_add'"
    }],
    staticClass: "fr",
    attrs: {
      "data-permission": "sea_freight_booking_list_add",
      "id": "sea_freight_booking_list_add",
      "data-sign": "sea_freight_booking_list_add",
      "type": "primary",
      "fbu-analyse-name": $t("\u65B0\u589E")
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v(" " + _vm._s(_vm.t('新增')))])], 1), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('my-table', {
    attrs: {
      "bordered": "",
      "name": "seaFreightBooking",
      "columns": _vm.columns,
      "useMouseTool": "",
      "data-sign": "sea_freight_booking_list",
      "data-source": _vm.dataList,
      "fixed-header": "",
      "is-filter-box": "",
      "row-selection": {
        selectedRowKeys: _vm.selectedList,
        onChange: _vm.onSelectChange
      },
      "row-key": "booking_order_code",
      "pagination": false
    },
    scopedSlots: _vm._u([{
      key: "booking_order_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('router-link', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.booking_order_code,
            expression: "record.booking_order_code"
          }],
          attrs: {
            "to": {
              name: 'SeaFreightBookingDetailsPage',
              query: {
                code: record.booking_order_code
              }
            }
          }
        }, [_vm._v(_vm._s(record.booking_order_code || '--'))])], 1);
      }
    }, {
      key: "order_status",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [record['order_status_text'] ? _c('span', [_vm._v(_vm._s(record.order_status_text))]) : _vm._e(), record['order_status'] === _vm.$enum.seaFreightBooking.seaFreightBookingStatus.REJECTED ? _c('span', [record.reject_reason ? _c('a-popover', [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(record.reject_reason))]), _c('a-icon', {
          staticClass: "ml-5",
          style: {
            fontsize: '18px',
            color: '#FF7E00'
          },
          attrs: {
            "type": "exclamation-circle",
            "theme": "filled"
          }
        })], 1) : _vm._e()], 1) : _vm._e()]);
      }
    }, {
      key: "create_time",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [record['create_time'] ? _c('div', [_vm._v(_vm._s(_vm.t('创建时间')) + "：" + _vm._s(record['create_time']))]) : _vm._e(), record['submit_time'] ? _c('div', [_vm._v(_vm._s(_vm.t('提交时间')) + "：" + _vm._s(record['submit_time']))]) : _vm._e(), record['verify_time'] ? _c('div', [_vm._v(_vm._s(_vm.t('审核时间')) + "：" + _vm._s(record['verify_time']))]) : _vm._e(), record['reject_time'] ? _c('div', [_vm._v(_vm._s(_vm.t('驳回时间')) + "：" + _vm._s(record['reject_time']))]) : _vm._e(), record['update_time'] ? _c('div', [_vm._v(_vm._s(_vm.t('更新时间')) + "：" + _vm._s(record['update_time']))]) : _vm._e()]);
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var record = ref.record;
        return _c('my-operation', {}, [[_vm.$enum.seaFreightBooking.seaFreightBookingStatus.DRAFT, _vm.$enum.seaFreightBooking.seaFreightBookingStatus.REJECTED].includes(record['order_status']) && record['source'] !== _vm.$enum.seaFreightBooking.SourceType.ARK ? [record.order_status ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'sea_freight_booking_edit',
            expression: "'sea_freight_booking_edit'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "sea_freight_booking_list_edit",
            "id": "sea_freight_booking_list_edit",
            "data-sign": "sea_freight_booking_list_edit",
            "fbu-analyse-name": $t("\u7F16\u8F91")
          },
          on: {
            "click": function ($event) {
              return _vm.handleEdit(record.booking_order_code);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('编辑')))]) : _vm._e()] : _vm._e(), [_vm.$enum.seaFreightBooking.seaFreightBookingStatus.DRAFT].includes(record['order_status']) ? [record.order_status ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'sea_freight_booking_submit',
            expression: "'sea_freight_booking_submit'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "sea_freight_booking_list_submit",
            "id": "sea_freight_booking_list_submit",
            "data-sign": "sea_freight_booking_list_submit",
            "fbu-analyse-name": $t("\u63D0\u4EA4")
          },
          on: {
            "click": function ($event) {
              return _vm.handleSubmitBooking(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('提交')))]) : _vm._e()] : _vm._e(), [_vm.$enum.seaFreightBooking.seaFreightBookingStatus.DRAFT, _vm.$enum.seaFreightBooking.seaFreightBookingStatus.REJECTED].includes(record['order_status']) && record['source'] !== _vm.$enum.seaFreightBooking.SourceType.ARK ? [record.order_status ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'sea_freight_booking_discard',
            expression: "'sea_freight_booking_discard'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "sea_freight_booking_list_discard",
            "id": "sea_freight_booking_list_discard",
            "data-sign": "sea_freight_booking_list_discard",
            "fbu-analyse-name": $t("\u5E9F\u5F03")
          },
          on: {
            "click": function ($event) {
              return _vm.handleDiscard(record.booking_order_code);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('废弃')))]) : _vm._e()] : _vm._e(), record.order_status ? _c('a', {
          directives: [{
            name: "permission",
            rawName: "v-permission",
            value: 'sea_freight_booking_edit',
            expression: "'sea_freight_booking_edit'"
          }],
          staticClass: "mr-10",
          attrs: {
            "data-permission": "sea_freight_booking_list_copy",
            "id": "sea_freight_booking_list_copy",
            "data-sign": "sea_freight_booking_list_copy",
            "fbu-analyse-name": $t("\u590D\u5236")
          },
          on: {
            "click": function ($event) {
              return _vm.handleCopy(record.booking_order_code);
            }
          }
        }, [_vm._v(_vm._s(_vm.t('复制')))]) : _vm._e()], 2);
      }
    }])
  })], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "isFixed": "",
      "value": _vm.searchData.page_index,
      "total": _vm.total,
      "name": "seaFreightBooking",
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  }), _c('bulk-search-modal', {
    ref: "bulkSearchModal",
    attrs: {
      "max-number": 30
    },
    on: {
      "bulkSearch": _vm.handleBulkFeedback
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };